// extracted by mini-css-extract-plugin
module.exports = {"switcherGroup":"StudentFormSwitcher_switcherGroup__ajZuc","switcherButton":"StudentFormSwitcher_switcherButton__YI279","active":"StudentFormSwitcher_active__n46h2"};